<!-----------------------------------------------------------------------------
  - Copyright (c) 2018. keni <$email>                                         -
  -                                                                           -
  - This file EventList.vue is part of event_pass_client.dev.                 -
  - Unauthorized copying of this file, via any medium is strictly prohibited. -
  - Proprietary and confidential                                              -
  - EventList.vue can not be copied and/or distributed                        -
  - without the express permission of keni                                    -
  ----------------------------------------------------------------------------->

<!--//Created by keni.-->
<!--//User: keni-->
<!--//Date: 23/03/2018-->
<!--//Time: 11:00-->

<template>
    <div v-if="(hasLink()||hardLink()) && location_link!='false'"
            class="row container"
            :class="readClass()"
         data-ref="has-link"

    >
        <!--date section-->
        <div class="col-4">
            <date-block
                    :date="item.start_date"
                    :add_time="addTime()"
            />
        </div>
        <!--details section-->
        <div class="col-8 border border-left-0 border-right-0 border-top-0 pb-2">
            <div v-if="(typeof location_link !== 'undefined' && location_link !== 'false')"
                 class="d-flex justify-content-end align-items-start
                align-self-top hover-show-watch--child text-right"
            >
                <a class="px-2 pb-2 pt-0 cursor-pointer"
                   :href="createLink(item)"
                >
                    <h6 class="h6 p-0">{{lang('title',item[path.data].lang)}}</h6>
                    <div>{{stripHtml(lang('description',item[path.data].lang).short)}}</div>
                </a>
            </div>
        </div>
    </div>
    <a v-else data-ref="!has-link" class="d-flex py-1" :href="createLink(item)">
        <!--date section-->
        <div
                data-element="date section"
                class="pr-3"
        >
            <date-block
             :date="item.start_date"
             :alt="item.created_at"
             :add_time="addTime()"></date-block>
        </div>
        <!--details section-->
        <div
                data-element="details section"
                class=""
                :class="{
            'w-100 border border-left-0 border-right-0 border-top-0 pb-2':showLastBorder()
        }"
        >
            <div class="h6 p-0">{{lang('title',item[path.data].lang)}}</div>
            <div>{{stripHtml(lang('description',item[path.data].lang).short)}}</div>
        </div>
    </a>
</template>

<script>
	import {
		getDate,
		getTime,
		setDate,
		getYear,
		getMonth,
		getDay
	} from '../../../../../app/Shared/Resources/Assets/js/helpers/format.date';
	import lang from '../../../../../app/Shared/Resources/Assets/js/helpers/lang';
	import {truncate} from '../../../../../app/Shared/Resources/Assets/js/helpers/format.string'

    // Vue.component('date-block',require('../dates/DateBlock'));
	export default {
		name: "event-list",
		components: {},
		props: [
			'last_link',
			'location_link',
			'base_class',
			'item',
			/**
			 * @param Object data   contains the target data field
			 * @param Object route  contains route information
			 */
			'path',
			'base_url',
			'add_time',
			'link',
			'event_link'
		],
		created() {
		},
		destroyed() {
		},
		mounted() {
// console.log('mounted', 'location_link',this.location_link);
		},
		data() {
			return {}
		},
		methods: {
			log(...args) {
				console.log(args);
			},
			stripHtml(html) {
				let tmp = document.createElement("DIV");
				tmp.innerHTML = html;
				let text = tmp.textContent || tmp.innerText || "";
				return truncate(text, 50);
			},
			truncate(text) {

			},
			showLastBorder() {
				if (typeof last_link !== 'undefined' && last_link !== null) {
					return (last_link);
				}
				else {
					return true;
				}
			},
			readClass() {
				// console.log('this.base_class',this.base_class);
				return this.base_class;
			},
			hardLink() {
				return typeof this.event_link !== 'undefined' && this.event_link !== null;
			},
			hasLink() {
				return typeof this.path.route !== 'undefined' && this.path.route !== null;
			},
			lang(path, object) {
				// console.log('object',object);
				// return;
				return lang(path, object)
			},
			/**
			 *
			 * creates link provided from the route
			 * @param item
			 */
			createLink(item) {

				if (this.hardLink()) {
					return this.event_link.data;
				}
				let structure = this.path.route.structure.split('.');

				let routeUrl = this.path.route.name.split('/');
				routeUrl.shift();

				// console.log(this.path.route.structure, 'structure', structure);
				// console.log(this.path.route.name, 'routeUrl', routeUrl);

				for (let i = 0; i < structure.length; i++) {
					let route_element = structure[i];

					if (route_element + '_expr' === routeUrl[i]) {
						routeUrl[i] = route_element + '--added';

						switch (route_element) {
							case 'date':
								routeUrl[i] = this.getDate(item.start_date, 'url_date');
								break;

							case 'slug':
								routeUrl[i] = item.slug;
								break;
						}
					}

				}

				// console.log('routeUrl', routeUrl);
				return this.base_url + '/' + routeUrl.join('/').toLowerCase();
				// return createUrlFromData(table_data, this.path.route);
			},
			addTime() {
				return typeof this.add_time !== 'undefined' && this.add_time !== null;

			},
			getDateString(date, type) {
				switch (type) {
					case 'year':
						return getYear(date, false);
					case 'month':
						return getMonth(date, 'name_short');
					case 'day':
						return getDay(date, 'num_short');
					case 'time':
						return getTime(date);
					default:
						console.error('no date defined', date);

				}

			},
			getDate(string, format) {
				// console.log(string, format);
				return getDate(string, format);
			},
			getTime(string) {
				return getTime(string);
			}
		},
		computed: {}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/lists/EventList.vue